"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDailyMatrixData = void 0;
const helpers_1 = require("../../../helpers");
const getHoursMatrixData_1 = require("./getHoursMatrixData");
const getDailyMatrixData = (selectedTimes, currentMatrixData, isAllSelected = false) => {
    const hoursMatrixData = getHoursMatrixData_1.getHoursMatrixData(currentMatrixData ? currentMatrixData : new Array(24).fill(isAllSelected));
    if (isAllSelected || !Array.isArray(selectedTimes) || !(selectedTimes === null || selectedTimes === void 0 ? void 0 : selectedTimes.length)) {
        return hoursMatrixData;
    }
    const times = helpers_1.getTimes();
    const indexes = times.reduce((acc, cur, idx) => {
        if (selectedTimes.includes(cur)) {
            acc.push(idx);
        }
        return acc;
    }, []);
    indexes.forEach((idx) => {
        hoursMatrixData[idx] = true;
    });
    return hoursMatrixData;
};
exports.getDailyMatrixData = getDailyMatrixData;
//# sourceMappingURL=getDailyMatrixData.js.map